import { createSelector } from 'reselect';

import { initialState } from './reducer';

const selectCreditCardsDomain = state => state.creditCards || initialState;

const makeSelectCreditCards = () =>
  createSelector(selectCreditCardsDomain, substate => substate.creditCards);

const makeSelectCreditCardsParams = () =>
  createSelector(selectCreditCardsDomain, substate => substate.params);

export { selectCreditCardsDomain, makeSelectCreditCards, makeSelectCreditCardsParams };
